export enum Token {
  CHANGE_PASSWORD  = 'ext_change_password',
  ESTABLISHMENT_ID = 'ext_establishment_id',
  USER_ID          = 'ext_userId',
  USERNAME         = 'ext_ds_login',
}
